import { reactive, ref, isRef } from 'vue'
import { ElMessage } from 'element-plus'
import { acceptFile, limitFileSize, downFile, getFileBounds } from '@/common/utils'
import { uploadFileApi } from '@/apis/sys'
import { exportErrorLog } from '@/apis'
export const useFileUpload = (fn, options = {}, domRef) => {
  const settings = { accept: '.xls,.xlsx', limit: 1, size: '10MB', ...options }
  const { width, height } = settings
  const state = reactive({
    processing: false,
    fileList: []
  })
  const showErrorTip = (name, type) => {
    if (type === 'accept') {
      ElMessage.error(`仅支持上传${settings.accept}格式文件`)
    } else if (type === 'width') {
      ElMessage.error(`请上传${width}*${height}大小的图片`)
    } else {
      ElMessage.error(`文件[${name}]超出限制大小[${settings.size}]`)
    }
  }
  // 文件上传之前
  const beforeUpload = async files => {
    if (Array.isArray(files)) {
      for (const file of files) {
        if (!acceptFile(file, settings.accept)) {
          showErrorTip(file.name, 'accept')
          // 注意 这里因为 element 内部组件的问题 不能直接return false
          return Promise.reject(new Error('file volidate error'))
        }
        if (!limitFileSize(file, settings.size)) {
          showErrorTip(file.name, 'limit')
          return Promise.reject(new Error('file volidate error'))
        }
      }
    } else {
      if (!acceptFile(files, settings.accept)) {
        showErrorTip(files.name, 'accept')
        return Promise.reject(new Error('file volidate error'))
      }
      if (!limitFileSize(files, settings.size)) {
        showErrorTip(files.name, 'limit')
        return Promise.reject(new Error('file volidate error'))
      }
      if (width || height) {
        const { fileWidth, fileHeight } = await getFileBounds(files)
        if (width !== fileWidth || fileHeight !== height) {
          showErrorTip(files.name, 'width')
          return Promise.reject(new Error('file volidate error'))
        }
      }
    }
    return Promise.resolve()
  }
  // 文件改变的时候
  const onChange = () => {}
  // 上传中
  const onProgress = event => {
    console.log('event', event)
    state.processing = true
  }
  // 上传成功
  const onSuccess = (file, files) => {
    console.log('onSuccess', file, files)
  }
  // 文件超出限制
  const onExceed = (files, fileList) => {
    ElMessage.warning(
      `当前限制上传${settings.limit}个文件,本次选择了 ${files.length} 个文件，共选择了 ${
        files.length + fileList.length
      } 个文件`
    )
  }
  // 自定义上传功能
  const httpRequest = file => {
    state.processing = true
    uploadFileApi(file.file)
      .then(res => {
        state.fileList.push(res.data)
        typeof fn === 'function' && fn(res.data, state.fileList)
      })
      .finally(() => {
        state.processing = false
      })
    if (isRef(domRef) && settings.limit === 1) {
      domRef.value?.clearFiles?.()
    }
  }
  // 删除之前
  const beforeRemove = () => {
    return true
  }
  return {
    settings,
    state,
    beforeUpload,
    onChange,
    onProgress,
    onSuccess,
    onExceed,
    httpRequest,
    beforeRemove
  }
}

/**
 * 下载失败记录
 * @returns
 */
export const useDownErrorRecord = () => {
  const loading = ref(false)
  const downFailRecord = async ids => {
    loading.value = true
    await exportErrorLog(ids)
    loading.value = false
  }
  return { downFailRecord, loading }
}

/**
 * 下载文件
 * @returns
 */
export const useDownFile = () => {
  const loading = ref(false)
  const handleDown = async (url, name) => {
    loading.value = true
    downFile(url, name)
    loading.value = false
  }
  return { handleDown, loading }
}
